module.exports = __webpack_public_path__ + "static/media/HomeworkIcon.4f5331a1.png";